export const jgApiUrl = 'https://jgqualifier-api-qa.azurewebsites.net';
export const searchServiceUrl = 'https://qawebservices.bowl.com/USBC.Search.Services';
export const ssoUrl = "https://qasignon.bowl.com";
export const siteUrl = "https://qajuniorgoldqualifier.bowl.com";


// WEBPACK FOOTER //
// ./src/config/settings.Staging.js